module.exports = __webpack_public_path__ + "static/media/100141.137370d1.png";